<template>
    <div
        class="cz3__step-container"
        :class="{
            'cz3__step-container--compact': compact,
        }"
    >
        <slot/>
    </div>
</template>

<style lang="scss">
    @import "../../style/variables.scss";

    .cz3__step-container {
        display: flex;
        flex-direction: column;

        gap: 20px;

        min-height: 260px;

        &.cz3__step-container--compact {
            gap: 24px;
        }

        @include respond-above(sm) {
            flex: 1 0 auto;

            gap: 32px;

            max-height: calc(100vh - 225px);
        }
    }
</style>

<script>
    export default {
        props: {
            compact: Boolean,
        },
    };
</script>
